import { Box, Typography } from '@mui/material';

type Params = {
    title: string;
    color?: string;
    height?: string;
    fontSize?: {
        xs: string,
        md: string
    };
}

const NavTitle = ({ title, height = '1.6875rem', color = 'secondary.main', fontSize = { xs: '1.25rem', md: '1.125rem' } }: Params) => {
    return (
        <Box sx={{ display: 'flex', alignItems: 'end', height: height, justifyContent: 'flex-start', gap: '.625rem' }}>
            <Box sx={{ width: '4px', height: '100%', backgroundColor: color }} />
            <Typography
                id='title-nav'
                fontWeight={700}
                paddingBottom='2px'
                sx={{
                    fontSize: fontSize
                }}>
                {title}
            </Typography>
        </Box>
    );
}

export default NavTitle;